import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import cart from './cart';
import profile from './proflle';
import cancelToken from "./cancelToken";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        loading: false,
        responsive: false,
        mainmenus: '',
        loginModel: false
    },
    mutations: {
        SET_LOADING: (state) => state.loading = true,
        SET_RESPONSIVE: (state, value) => state.responsive = value,
        UNSET_LOADING: (state) => state.loading = false,
        OPEN_LOGIN_MODEL: (state) => state.loginModel = true,
        CLOSE_LOGIN_MODEL: (state) => state.loginModel = false
    },
    modules: {
        user,
        cart,
        profile,
        cancelToken
    }
});
export default store;
